import PropTypes from 'prop-types'

import {Map} from 'immutable'

import ClientPrivacyNoticeModal from '../../../../../shared_components/ClientPrivacyNoticeModal'
import FuneralHomeClientPrivacyNoticeModal from '../../../../../shared_components/FuneralHomeClientPrivacyNoticeModal'

import {BoxGutterMedium} from '../../blocks/Boxes'
import {TextGutterMedium} from '../../blocks/Texts'

export const Privacy = ({advisorContactCard, firmOwnership}) => {
  const advisorFullName = advisorContactCard.get('name')

  const privacyText = advisorContactCard.get('firm-type') === 'funeral_home' ?
    'authorized representatives of that funeral home' :
    advisorFullName

  return (
    <BoxGutterMedium className='privacy'>
      <h2>Privacy Notice</h2>
      <TextGutterMedium>
        Your account comes courtesy of {advisorFullName}. In order to help you
        progress in your Everplan, certain information about how you are using
        your account may be shared with {privacyText}.
      </TextGutterMedium>
      {
        advisorContactCard.get('firm-type') === 'funeral_home' ?
          <FuneralHomeClientPrivacyNoticeModal
            editableItemIds={firmOwnership.get('edit-item-ids')}
            linkText='Learn More »'
          /> :
          <ClientPrivacyNoticeModal
            advisorFullName={advisorFullName}
            linkText='Learn More »'
          />
      }
    </BoxGutterMedium>
  )
}

Privacy.propTypes = {
  advisorContactCard: PropTypes.instanceOf(Map),
  firmOwnership: PropTypes.instanceOf(Map)
}

export default Privacy
